import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from "ngx-bootstrap";
import { ValidationSummary } from "app/validation/validation-display/validation-summary.component";
import { NotificationService } from "app/shared/utils/notification.service";

@NgModule({
    imports: [
        CommonModule,
        AlertModule
    ],
    declarations: [
        ValidationSummary
    ],
    providers: [
        NotificationService
    ],
    exports: [
        ValidationSummary
    ]
})
export class ValidationModule { }


// WEBPACK FOOTER //
// ./src/app/validation/validation.module.ts